import Vue from "vue";

Vue.filter("clear_cpf_cnpj", function(value) {
  if (!value) {
    return "";
  }
  return value.replace(/[^a-zA-Z0-9 ]/g, "");
});
